export const GET_TOTAL_STATS = 'OP/get_total_stats';
export const GET_GRAPH_STATS = 'OP/get_graph_stats';
